import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LS_AI_IMAGE_GENERATION_STATUSES } from '../../../common/constants/ls';
import { ProductId } from '../../../modules/pages/page-form/page-form';

export interface InitialAiImagesGenerationStatusState {
  statuses: {
    id: string
    asins: ProductId[],
    status: 'none' | 'in-progress'
    isCompleted: boolean
  }[];
}

type ChangeEntityAction =
  PayloadAction<{ id: string, values: Partial<InitialAiImagesGenerationStatusState['statuses'][number]> }>;

type CheckStatusAction =
  PayloadAction<InitialAiImagesGenerationStatusState['statuses'][number]>;

const initialState: InitialAiImagesGenerationStatusState = {
  statuses: ((JSON
    .parse(localStorage.getItem(LS_AI_IMAGE_GENERATION_STATUSES))
    || []) as InitialAiImagesGenerationStatusState['statuses'])
    .filter((elem) => elem.status === 'in-progress' || !elem.isCompleted) || [],
};

export const aiImagesGenerationStatusSlice = createSlice({
  initialState,
  name: 'aiImagesGenerationStatus',
  reducers: {
    changeEntity: (state: InitialAiImagesGenerationStatusState, action: ChangeEntityAction) => {
      const statuses = state.statuses.map((elem) => {
        if (elem.id === action.payload.id) {
          return { ...elem, ...action.payload.values };
        }
        return elem;
      });
      localStorage.setItem(LS_AI_IMAGE_GENERATION_STATUSES, JSON.stringify(statuses));
      return ({
        ...state,
        statuses,
      });
    },
    checkStatus: (state: InitialAiImagesGenerationStatusState, action: CheckStatusAction) => {
      const isExist = state.statuses.some((elem) => elem.id === action.payload.id);

      if (isExist) return state;

      localStorage.setItem(LS_AI_IMAGE_GENERATION_STATUSES, JSON.stringify([...state.statuses, action.payload]));
      return ({
        ...state,
        statuses: [...state.statuses, action.payload],
      });
    },
  },
});
